/***
 * 存放节点、节点数据、节点通知相关的枚举值
 */

export const NodeDefaultWidth = 300;
export const NodeDefaultHeight = 100;
export const ConditionNodeDefaultSize = 138;
export const EdgeType = 'endpoint';
export const NodeOffsetY = 80; // Y轴方向节点的间隔
export const NodeOffsetX = 80; // X轴方向节点的间隔

// 流程保存类型
export const SaveMode = {
    Create: 0, // 保存为新模板
    Update: 1 // 更新已存在的模板
}

export const ESOP_TASK_OPERATOR_TYPE = {
    PROCESS:0,
    TIMEOUT:1,
    COMPLETE:2,
    FOLLOW_UP:3,
    UPDATE_INCIDENT_LEVEL:4
}
// 节点类型
export const NodeType = {
    Start: 10001,
    End: 10002,
    Reviewer: 10003,
    Branch: 10004,
    Dispatch: 10005,
    Task: 10006,
    Approvals: 10007,
    Parallel: 10008,
    BranchMore: 10009,
}

// 节点数据
export const NodeData = {
    [NodeType.Start]: {
        name: 'Start',
        nodeDataEr: 'Start',
        nodeDataNoun: 'Start',
        nodeDataDo: 'Start',
        nodeHandleName: 'Start',
        color: '#059FE8',
        icon: 'icon-sv-UserCenter',
        svgIcon: '',
        width: 64,
        height: 64,
    },
    [NodeType.End]: {
        name: 'End',
        nodeDataEr: 'End',
        nodeDataNoun: 'End',
        nodeDataDo: 'End',
        nodeHandleName: 'End',
        color: '#536372',
        svgIcon: '',
        width: 64,
        height: 64,
    },
    [NodeType.Reviewer]: {
        name: 'Review',
        nodeDataEr: 'Reviewer',
        nodeDataNoun: 'Review',
        nodeDataDo: 'Review',
        nodeHandleName: 'Review',
        color: '#6F42A2',
        icon: 'icon-sv-review',
        width: 300,
        height: 100,
        svgIcon: '<path d="M961.9995 740.742814a91.625094 91.625094 0 0 0-91.369158-91.497125h-74.285428a7.550112 7.550112 0 0 1-7.486129-7.550113v-10.429393a12.796801 12.796801 0 0 1 4.990753-9.405648 140.764809 140.764809 0 1 0-199.054237-6.398401c2.175456 2.303424 4.47888 4.606848 7.358161 7.294177a11.325169 11.325169 0 0 1 4.094976 7.35816v11.645089a7.486128 7.486128 0 0 1-7.486129 7.486129H524.348913a91.625094 91.625094 0 0 0-91.56111 91.561109v140.764809h529.339665z m-83.755061 57.137716H516.670832v-57.137716a7.486128 7.486128 0 0 1 7.486129-7.550112h74.285428a91.625094 91.625094 0 0 0 91.56111-91.56111v-11.645089a95.144214 95.144214 0 0 0-30.52037-69.550612 57.137716 57.137716 0 0 1 34.423394-99.815046 55.346163 55.346163 0 0 1 41.333667 14.332417 57.009748 57.009748 0 0 1 4.734816 80.747813 31.992002 31.992002 0 0 1-3.1992 3.327168 95.976006 95.976006 0 0 0-31.992002 69.934516v12.796801a91.689078 91.689078 0 0 0 91.625094 91.56111h74.349412a7.422144 7.422144 0 0 1 7.486129 7.486128z"  ></path><path d="M474.313422 939.669083l-41.781555 0.383904v83.755061h529.339665v-84.138965z"  ></path><path d="M155.033242 907.549113V116.514871a23.482129 23.482129 0 0 1 23.418145-23.418145h79.020245v151.002249a55.410147 55.410147 0 0 0 59.313172 50.547363h327.91802a55.474131 55.474131 0 0 0 59.44114-50.547363v-151.002249h78.956261a23.482129 23.482129 0 0 1 23.546113 23.418145v190.288428h93.032742V116.514871A116.706823 116.706823 0 0 0 782.908273 0H178.579355A116.642839 116.642839 0 0 0 62.064484 116.578855v790.970258a116.578855 116.578855 0 0 0 116.514871 116.514871h147.163209v-93.032742h-147.163209a23.610097 23.610097 0 0 1-23.546113-23.482129zM340.138965 93.224694h281.145714v132.446888H340.138965z"  ></path>'
    },
    [NodeType.Branch]: {
        name: 'Branch',
        nodeDataEr: 'Branch',
        nodeDataNoun: 'Branch',
        nodeDataDo: 'Branch',
        nodeHandleName: 'Branch',
        color: 'transparent',
        icon: 'icon-sv-conditionalbranch',
        img:"url('/static/img/esop-diamond-branch.png')",
        width: 140,
        height: 140,
        svgIcon: '<path d="M933.952 643.648h-56.256V512a43.904 43.904 0 0 0-43.904-43.904H556.48V380.352h151.168a82.368 82.368 0 0 0 82.304-82.24V82.304A82.368 82.368 0 0 0 707.648 0.064H316.288a82.368 82.368 0 0 0-82.24 82.24v215.808a82.368 82.368 0 0 0 82.24 82.24h152.384v87.744H190.144A43.904 43.904 0 0 0 146.24 512v131.648h-56.256a90.112 90.112 0 0 0-90.048 90.048v200.256A90.112 90.112 0 0 0 89.984 1024h200.256a90.112 90.112 0 0 0 90.048-90.048v-200.256a90.112 90.112 0 0 0-90.048-90.048h-56.256V555.904h555.904v87.744h-56.256a90.112 90.112 0 0 0-90.048 90.048v200.256A90.112 90.112 0 0 0 733.632 1024h200.256a90.112 90.112 0 0 0 90.048-90.048v-200.256a90.112 90.112 0 0 0-89.984-90.048zM321.792 87.744h380.352v204.8H321.792z m-29.248 645.952v200.256a2.304 2.304 0 0 1-2.304 2.304l-202.496-2.304 2.304-202.496z m643.648 200.256a2.304 2.304 0 0 1-2.24 2.304l-202.496-2.304 2.24-202.496 202.496 2.304z"  ></path>'
    },
    [NodeType.Dispatch]: {
        name: 'Dispatch',
        nodeDataEr: 'Executor',
        nodeDataNoun: 'Execution',
        nodeDataDo: 'Execute',
        nodeHandleName: 'Dispatch',
        color: '#31A6C4',
        icon: 'icon-sv-dispatch',
        width: 300,
        height: 100,
        svgIcon: '<path d="M768.448 336.64a317.44 317.44 0 1 0-502.016 257.088A451.328 451.328 0 0 0 0 1004.8h100.288a351.232 351.232 0 0 1 350.72-350.848 317.76 317.76 0 0 0 317.44-317.312z m-317.44 217.152A217.152 217.152 0 1 1 668.16 336.64a217.6 217.6 0 0 1-217.152 217.152z"  ></path><path d="M818.176 611.136l-61.184 67.008 94.144 86.016h-264.96v90.752h264.064l-81.152 88.896 67.008 61.184L1024 799.104z"  ></path>'    
    },
    [NodeType.Task]: {
        name: 'Task',
        nodeDataEr: 'Executor',
        nodeDataNoun: 'Execution',
        nodeDataDo: 'Execute',
        nodeHandleName: 'Task',
        color: '#003C97',
        icon: 'icon-sv-task',
        width: 300,
        height: 100,
        svgIcon: '<path d="M988.352586 82.55733a49.27344 49.27344 0 0 0-46.009875-4.671379l-140.781259 57.592333A260.829277 260.829277 0 0 1 528.893751 89.724375a360.464013 360.464013 0 0 0-390.348035-55.928554l-95.987222 44.794037a49.209449 49.209449 0 0 0-28.284234 44.794037v900.680096h98.162932v-345.553998l67.702987-31.611791a262.365073 262.365073 0 0 1 284.122176 40.63459 358.352294 358.352294 0 0 0 374.670122 62.775643l140.781259-57.592333a49.145458 49.145458 0 0 0 30.523936-45.433951V123.319903a49.209449 49.209449 0 0 0-21.885086-40.762573z m-76.789778 531.513242l-110.449296 45.305968a260.95726 260.95726 0 0 1-272.667701-45.753909 360.400022 360.400022 0 0 0-390.348035-55.928554l-26.108525 12.222373V154.547746l67.702987-31.5478a262.365073 262.365073 0 0 1 284.122177 40.63459 358.352294 358.352294 0 0 0 374.670122 62.775643l73.270246-30.012005z"  ></path>'
    },
    [NodeType.Approvals]: {
        name: 'Approvals',
        nodeDataEr: 'Approver',
        nodeDataNoun: 'Approval',
        nodeDataDo: 'Approve',
        nodeHandleName: 'Approvals',
        color: '#1C7D66',
        icon: 'icon-sv-approvals',
        width: 300,
        height: 100,
        svgIcon: '<path d="M66.033335 934.793868V1024h891.93333v-89.590089H110.636401z m758.124133-445.966665h-133.809198a44.795045 44.795045 0 0 1-44.795044-44.795044v-20.989678a54.393983 54.393983 0 0 1 18.749925-37.435859 222.887343 222.887343 0 1 0-304.158352 0.447951 52.15423 52.15423 0 0 1 18.301975 36.987908v20.989678a44.795045 44.795045 0 0 1-44.795044 44.795044h-134.385134a133.809197 133.809197 0 0 0-133.809197 133.809198v222.951336H957.390729V622.636401a133.809197 133.809197 0 0 0-133.809198-133.809198z m44.795044 267.554402H155.239467v-133.745204a44.795045 44.795045 0 0 1 44.795044-44.795045h133.809198a133.809197 133.809197 0 0 0 133.809197-133.809197v-20.989678a139.12061 139.12061 0 0 0-44.795045-102.388673 134.385134 134.385134 0 1 1 180.588023-2.687703 140.784426 140.784426 0 0 0-46.842818 103.028602v22.717487a133.809197 133.809197 0 0 0 133.809197 133.809198h133.809198a44.795045 44.795045 0 0 1 44.795044 44.795044z"  ></path>'
    },
    // UNDO Branch More
    [NodeType.BranchMore]: {
        name: 'Branch',
        nodeDataEr: 'Branch',
        nodeDataNoun: 'Branch',
        nodeDataDo: 'Branch',
        nodeHandleName: 'Branch',
        color: 'transparent',
        icon: 'icon-sv-conditionalbranch',
        width: 140,
        height: 140,
        svgIcon: '<path d="M933.952 643.648h-56.256V512a43.904 43.904 0 0 0-43.904-43.904H556.48V380.352h151.168a82.368 82.368 0 0 0 82.304-82.24V82.304A82.368 82.368 0 0 0 707.648 0.064H316.288a82.368 82.368 0 0 0-82.24 82.24v215.808a82.368 82.368 0 0 0 82.24 82.24h152.384v87.744H190.144A43.904 43.904 0 0 0 146.24 512v131.648h-56.256a90.112 90.112 0 0 0-90.048 90.048v200.256A90.112 90.112 0 0 0 89.984 1024h200.256a90.112 90.112 0 0 0 90.048-90.048v-200.256a90.112 90.112 0 0 0-90.048-90.048h-56.256V555.904h555.904v87.744h-56.256a90.112 90.112 0 0 0-90.048 90.048v200.256A90.112 90.112 0 0 0 733.632 1024h200.256a90.112 90.112 0 0 0 90.048-90.048v-200.256a90.112 90.112 0 0 0-89.984-90.048zM321.792 87.744h380.352v204.8H321.792z m-29.248 645.952v200.256a2.304 2.304 0 0 1-2.304 2.304l-202.496-2.304 2.304-202.496z m643.648 200.256a2.304 2.304 0 0 1-2.24 2.304l-202.496-2.304 2.24-202.496 202.496 2.304z"  ></path>'
    },
    // UNDO Parallel
    [NodeType.Parallel]: {
        name: 'Parallel',
        nodeDataEr: 'Parallel',
        nodeDataNoun: 'Parallel',
        nodeDataDo: 'Parallel',
        nodeHandleName: 'Parallel',
        color: 'transparent',
        icon: 'icon-sv-approvals',
        width: 140,
        height: 140,
        img:"url('/static/img/esop-diamond.png')",
        svgIcon: '<path d="M856.362667 440.149333a30.464 30.464 0 0 1-42.666667 1.066667 31.488 31.488 0 0 1-9.173333-22.144v-84.778667h-98.133334l-140.373333 140.8a38.186667 38.186667 0 0 1-54.016-54.016l151.722667-151.722666a37.930667 37.930667 0 0 1 27.008-10.794667h113.92v-72.533333a29.866667 29.866667 0 0 1 30.762666-29.866667 31.829333 31.829333 0 0 1 21.077334 8.533333l116.650666 116.650667a29.866667 29.866667 0 0 1 0 42.666667z m-317.610667 83.712a14.976 14.976 0 0 1 4.864 0.554667 31.530667 31.530667 0 0 1 29.140333 17.834667l133.376 133.376h98.133334v-72.533334a29.866667 29.866667 0 0 1 30.762666-29.866666 31.829333 31.829333 0 0 1 21.077334 8.533333l116.650666 116.650667a29.866667 29.866667 0 0 1 0 42.666666l-116.650666 116.650667a30.464 30.464 0 0 1-42.666667 1.066667 31.488 31.488 0 0 1-9.173333-22.144v-84.778667h-113.92a37.930667 37.930667 0 0 1-27.008-10.794667l-140.8-140.482666h-187.733334a148.266667 148.266667 0 1 1 0.554667-76.117334z m-348.288-38.4a76.117333 76.117333 0 1 0 76.117333 76.117334 76.032 76.032 0 0 0-75.989333-76.074667z"  ></path>'
    },
}

// 节点处理方式
export const NodeHandleType = {
    Agree: '00000000-0000-0000-0000-000000000001',
    Approve: '00000000-0000-0000-0000-000000000002',
    Reject: '00000000-0000-0000-0000-000000000003'
}

// 节点连接方式
export const NodeConnectMethod = {
    SeriesWound: 0, // 串联的
    ShuntWound: 1, // 并联的
}

// 节点通知类型，Started = 10000 开始, Approved = 10001 审批通过, Agreed = 10002 审核通过,Rejected = 10003拒绝,10004派遣成功时
export const NotifyConfigType = {
    Start: 10000,
    Approved: 10001,
    Agreed: 10002,
    Rejected: 10003,
    Dispatched: 10004,
    NodeTimeOut:10005,
    NodeComplete:10006
}

// 节点中处理人的派遣方式
export const NodePersonDispatchType = {
    LastNode: 0, // 由上一个节点的处理者进行派遣
    DetailHandler: 1, // 为当前节点指定用户或用户组或账号
    Reuse:2,//同上
};
// 节点中处理人的角色类型
export const NodeHandlerRoleType = {
    // Approver: 10001,
    // Reviewer: 10002,
    // ManagingAgent: 10003,
    // Executor: 10006,

    /***
     * UNDO 未完成，具体枚举值需由后台定
     */
    // Approver: 10001,
    // GSOCCOperator: 10002,
    // GroundSupervisor: 10003,
    // SecurityOfficer: 10006,
};

export const NodeHandlerRoleTypeMap = {
    // [NodeHandlerRoleType.Approver]: {
    //     value: NodeHandlerRoleType.Approver,
    //     label: 'Approver'
    // },
    // [NodeHandlerRoleType.GSOCCOperator]: {
    //     value: NodeHandlerRoleType.GSOCCOperator,
    //     label: 'GSOCC Operator'
    // },
    // [NodeHandlerRoleType.GroundSupervisor]: {
    //     value: NodeHandlerRoleType.GroundSupervisor,
    //     label: 'Ground Supervisor'
    // },
    // [NodeHandlerRoleType.SecurityOfficer]: {
    //     value: NodeHandlerRoleType.SecurityOfficer,
    //     label: 'Security Officer'
    // }
};
export  const ReceiveRole = {
    ROLE:2,
    ACCOUNT:0,
    ACCOUNT_GROUP:1,
    HANDHELD:4
}


//////////////////
// WEBPACK FOOTER
// ./src/admin/components/incidentManagement/components/esop/utils/enum.js
// module id = 2RpX
// module chunks = 15